
import axios from 'axios'
import Servers from "../../server"

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async getFacialVisitsReport(context, params) {
      let response = await axios.get(
        `${Servers.serverApi}api/facial-visits?${params.query}`,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      );
      return response
    },
    async getFacialVisitsExport(context, params) {
      let response = await axios.get(
        `${Servers.serverApi}api/facial-visits?${params.query}`,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      );
      return response
    }
  }
}
